import React from 'react';
import PropTypes from 'prop-types';

import { H1 } from 'components/atoms/Typography';
import { Container } from 'components/core/Page';
import { SearchBox } from 'components/molecules/SearchBox';
import { PSPMarkdownContent } from 'components/psp/PSPMarkdown';
import { StickySearchBar } from 'components/landing/StickySearchBar';

import { Image } from 'components/atoms';
import './PSPHero.scss';
import { useSearchHandler } from 'decorators/withSearchHandler';

function PSPHero({ content, handleSearch: handleSearchProp, searchType, searchParams, searchPath }) {
	const { handleSearch: hookHandleSearch } = useSearchHandler({ searchType, searchParams, searchPath });
	const handleSearch = handleSearchProp || hookHandleSearch;
	const {
		title,
		description,
		image,
		CTAText,
		pageType,
		inputLabel,
		additionalProps = {},
	} = content;
	return (
		<>
			<header className="psp-hero">
				<Container className="psp-hero-content">
					<div className="psp-hero-left">
						<Image
							className="psp-hero-image"
							src={image}
							alt={title}
							lazyload={false}
						/>
					</div>
					<div className="psp-hero-right">
						<div className="psp-hero-heading">
							<H1
								size="xlarge"
								color="black"
								weight="ultraBold"
								className={`${
									pageType === 'SGP'
										? 'sgp-hero-title'
										: 'psp-hero-title'
								}`}
								{...additionalProps?.heading}
							>
								{title}
							</H1>
							<PSPMarkdownContent
								content={description}
								additionalProps={{
									paragraph: { color: 'black' },
									anchor: { color: 'black' },
								}}
							/>
						</div>
						<SearchBox
							id="psp-hero-sticky-search"
							inputLabel={`${
								pageType === 'SGP'
									? inputLabel
									: 'Enter address, city or zip'
							}`}
							handleSearch={handleSearch}
							hideOnScroll
							buttonText={
								pageType === 'SGP'
									? (CTAText ?? 'Find the best deal')
									: (CTAText ?? 'Find Storage Near You')
							}
							pinkButton
						/>
					</div>
				</Container>
			</header>
			<StickySearchBar
				triggerId="psp-hero-sticky-search"
				handleSearch={handleSearch}
			/>
		</>
	);
}

PSPHero.propTypes = {
	content: PropTypes.shape({
		title: PropTypes.string.isRequired,
		description: PropTypes.string.isRequired,
		image: PropTypes.string.isRequired,
		CTAText: PropTypes.string,
		pageType: PropTypes.string,
		inputLabel: PropTypes.string,
	}).isRequired,
	handleSearch: PropTypes.func,
	additionalProps: PropTypes.object,
	searchType: PropTypes.string,
	searchParams: PropTypes.object,
	searchPath: PropTypes.string,
};

export default PSPHero;
